import React, {useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import TermOfUser from '../termsOfUser/index.jsx';
import { BodyContent } from './BodyContent.jsx';
import { DepositWrapperStyled } from './styled.jsx';
import { Modal } from '../modal/index.jsx';
import ErrorIcon from '../../assets/error-icon.svg';
import * as AppActions from '../../stores/app/actions';
import { useDispatch } from 'react-redux';
import { getTransactionInfo } from '../../utils/sessionStorage';


const Deposit = React.memo(({ onClickBack = null, onClickClose = null, isMobile = false, obvInfo = {}, error = {} }) => {
  const [viewTC, setViewTC] = useState(false);
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const transactionInfo = useMemo(() => {
    return getTransactionInfo() || obvInfo || {};
  }, [obvInfo]);

  useEffect(() => {
    if (error?.message) {
      setIsModalVisible(true);
    }
  }, [error]);

  const handleConfirm = (clientReferenceId) => {
    dispatch(AppActions.confirmationBank(clientReferenceId));
  };

  // TODO manh.dam add loading or skeleton when submit confirm
  // if(isConfirm) {
  //   return <Confirmed
  //     obvInfo={obvInfo}
  //     isConfirm={isConfirm}
  //     backMerchant={backMerchant}
  //   />
  // }

  return (
      <DepositWrapperStyled customStyle={{isMobile}}>
        <div className='box-extend'>
          {
            viewTC ?
                <TermOfUser setViewTC={setViewTC}/> :
                <BodyContent
                    setViewTC={setViewTC}
                    obvInfo={transactionInfo}
                    onClickClose={onClickClose}
                    handleConfirm={handleConfirm}
                />
          }
          <Modal
              message={error?.message}
              subMessage={error?.subMessage}
              description={error?.description}
              errorUrl={ErrorIcon}
              isFullScreen={true}
              visible={isModalVisible}
              onClickBack={onClickBack}
              obvInfo={obvInfo}
          />
        </div>
      </DepositWrapperStyled>
  );
});

Deposit.propTypes = {
  /**
   * Back Merchant when user click Back to merchant button
   */
  onClickBack: PropTypes.func,
  /**
   * Callback funcion when user click close button
   */
  onClickClose: PropTypes.func,
  /**
   * If value = true device app is mobile or tablet
   */
  isMobile: PropTypes.bool,
  /**
   * If isConfirm = true api confirm success
   */
  isConfirm: PropTypes.bool,
  /**
   *  If call api confirm failed -> show screen error
   */
  error: PropTypes.object,
  obvInfo: PropTypes.object,
};


Deposit.displayName = "Deposit";
export default Deposit;
